import React from 'react';
import PolicyLayout from '../components/PolicyLayout';
import SEOHead from '../components/SEOHead';
import { getSEOConfig } from '../utils/seoConfig';

const PrivacyPolicyPage: React.FC = () => {
  const seoConfig = getSEOConfig('/privacy');

  return (
    <>
      <SEOHead
        title={seoConfig.title}
        description={seoConfig.description}
        keywords={seoConfig.keywords}
        ogType={seoConfig.ogType}
      />
      <PolicyLayout title="Privacy Policy" lastUpdated="October 2025">
        <p>
          Your privacy is important to us at Gelwel. This Privacy Policy explains how we collect, use, and protect your information.
        </p>

        <h2>1. Information We Collect</h2>
        <p>We collect the following types of information:</p>
        <ul>
          <li>Personal information you provide when creating an account</li>
          <li>Usage data and analytics</li>
          <li>Device information and cookies</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Provide and improve our services</li>
          <li>Personalize your experience</li>
          <li>Communicate with you about updates and features</li>
          <li>Ensure security and prevent fraud</li>
        </ul>

        <h2>3. Data Security</h2>
        <p>
          We implement industry-standard security measures to protect your data from unauthorized access, disclosure, or destruction.
        </p>

        <h2>4. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal data</li>
          <li>Request corrections or deletions</li>
          <li>Opt-out of marketing communications</li>
          <li>Export your data</li>
        </ul>

        <h2>5. Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy, please contact us at{' '}
          <a href="mailto:paulfortuneltd@gmail.com">paulfortuneltd@gmail.com</a>
        </p>
      </PolicyLayout>
    </>
  );
};

export default PrivacyPolicyPage;
